/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */

export const metadata = {
  title: 'GLSL Syntax'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`GLSL Syntax`}</h1>
    <p>{`Shaders will always have a `}<inlineCode parentName="p">{`main`}</inlineCode>{` function, like so:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-glsl"
      }}>{`void main () {
  // ... shader functionality ...
}
`}</code></pre>
    <p>{`When you create variables, you have to specify their type:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`float`}</inlineCode>{` - a simple float value, e.g. `}<inlineCode parentName="p">{`0.75`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`vec2`}</inlineCode>{`, `}<inlineCode parentName="p">{`vec3`}</inlineCode>{`, `}<inlineCode parentName="p">{`vec4`}</inlineCode>{` - vectors like `}<inlineCode parentName="p">{`(x, y)`}</inlineCode>{` or `}<inlineCode parentName="p">{`(r, g, b)`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`int`}</inlineCode>{` - integer, e.g. `}<inlineCode parentName="p">{`4`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`bool`}</inlineCode>{` - boolean `}<inlineCode parentName="p">{`true`}</inlineCode>{` or `}<inlineCode parentName="p">{`false`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`sampler2D`}</inlineCode>{` — holds a WebGL texture`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`mat2`}</inlineCode>{`, `}<inlineCode parentName="p">{`mat3`}</inlineCode>{`, `}<inlineCode parentName="p">{`mat4`}</inlineCode>{` - matrix data types`}</p>
      </li>
    </ul>
    <p>{`For example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-glsl"
      }}>{`void  main () {
  float a = 25.0;
  int i = 5;
  bool b = true;
}
`}</code></pre>
    <p>{`The `}<em parentName="p">{`vec`}</em>{` types accept other vectors as parameters, but you have to make sure the number of components match:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-glsl"
      }}>{`float alpha = 0.5;
vec3 rgb = vec3(1.0); // (1, 1, 1)
vec4 myRGBA = vec4(rgb, alpha); // (1, 1, 1, 0.5)
`}</code></pre>
    <p>{`You can access vectors with `}<inlineCode parentName="p">{`.xyzw`}</inlineCode>{` or `}<inlineCode parentName="p">{`.rgba`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-glsl"
      }}>{`vec2 xy = myRGBA.xy;
vec2 rgb = myRGBA.rgb;
float alpha = myRGBA.a;
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
